import 'whatwg-fetch';

const refreshPopularPosts = (el) => {
  el.querySelector('.e-preloader').classList.remove('e-preloader--hidden');

  const fetchPosts = () => fetch(`${wp_data.restUrl}wordpress-popular-posts/v1/popular-posts?limit=5&time_unit=week&time_quantity=1`)
    .then(response => response.json())
    .then(json => json);

  fetchPosts().then((results) => {
    el.querySelector('.e-preloader').classList.add('e-preloader--hidden');

    if (results.length) {
      results.forEach((result, index) => {
        el.innerHTML += `<li><span>${index + 1}<span>.</span></span> <a href="${result.link}">${result.title.rendered}</a></li>`;
      });
    } else {
      // No results
    }
  });
};

const list = document.querySelector('#ci-popular-posts .e-list.e-list--popular');

if (list) {
  refreshPopularPosts(list);
}
